<template>
  <div style="display: contents">
    <div style="display:inline-block" v-bind:style="{ width: getWidth }">
      <v-text-field v-model="model"
                    :label="valueItem.label"
                    :disabled="disabled"
                    :error-messages="validationErrors"
                    :readonly="!manual"
                    :hint="hint" :persistent-hint="true"
                    stack-label outlined dense class="mr-4" attach>
        <template v-slot:append-outer>
          <v-menu ref="datePicker"
                  v-model="datePicker"
                  @input="emitInputEvent"
                  :disabled="disabled"
                  :close-on-content-click="false"
                  :return-value.sync="model"
                  transition="scale-transition"
                  min-width="auto" attach
                  :top="openTop">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" v-if="!getShowProgress">mdi-calendar</v-icon>
            </template>
            <v-date-picker v-model="pickerModel" no-title scrollable attach dense @input="$refs.datePicker.save(model); datePicker = false" />
          </v-menu>
        </template>
      </v-text-field>
    </div>
    <v-progress-circular indeterminate color="primary" :width="2" :size="20" dense v-if="getShowProgress" style="display: inline-block;"></v-progress-circular>
  </div>
</template>
<script>
  // WrsViDate.vue

  export default {
    data: () => ({
      datePicker: false,
    }),
    props: {
      valueItem: {
        type: Object,
        default: function () {
          return {
            value: "",
            textLength: 0,
            textLengthError: "",
            label: "",
            isRequired: false,
            requiredError: "",
            error: "",
            hasError: false
          };
        },
      },
      externalErrorMessage: {
        type: String,
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      },
      showProgress: {
        type: Boolean,
        default: false
      },
      manual: {
        type: Boolean,
        default: true
      },
      dateFormat: {
        type: String,
        default: "YYYY/MM/DD"
      },
      dateFormatPicker: {
        type: String,
        default: "YYYY-MM-DD"
      },
      size: {
        type: Number,
        default: 200
      },
      openTop: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      model: {
        get: function () {
          return this.calculateDO(this.valueItem.value).date;
        },
        set: function (newValue) {
          this.valueItem.value = this.calculateDO(newValue).date;
          this.emitInputEvent();
        },
      },
      hint: {
        get: function () {
          return this.calculateDO(this.valueItem.value).hint;
        },
      },
      pickerModel: {
        get: function () {
          return this.calculateDO(this.valueItem.value).pickerDate;
        },
        set: function (newValue) {
          this.valueItem.value = this.calculateDO(newValue).date;
          this.emitInputEvent();
        },
      },
      validationErrors() {
        const errors = [];

        this.checkForErrors(this.valueItem, this.externalErrorMessage);

        if (this.valueItem.hasError) errors.push(this.valueItem.error);
        return errors;
      },
      getShowProgress() {
        return this.showProgress;
      },
      getWidth() {
        if (this.size <= 0)
          return '200px';
        else
          return this.size + 'px';
      },
    },
    methods: {
      checkForErrors: function (vi, eem) {
        if (eem) {
          if (eem != "") {
            vi.hasError = true;
            vi.error = eem;
            return;
          }
        }

        if (vi.isRequired && (vi.value == null || vi.value == "")) {
          vi.hasError = true;
          vi.error = vi.requiredError;
          return;
        }

        if (!this.calculateDO(vi.value).isDate) {
          vi.hasError = true;
          vi.error = "Please enter valid date in a format " + this.dateFormat;
          return;
        }

        vi.hasError = false;
        vi.error = "";
      },
      emitInputEvent: function () {
        this.$emit('input');
      },
      getDatePartIndex(datePart, format, splitString) {
        let df = format.split(splitString);
        for (var iMi = 0; iMi < 3; iMi++) {
          if (df[iMi] == datePart) {
            return iMi;
          }
        }
        return -1;
      },
      calculateDO(date) {
        this.valueItem.year = 0;
        this.valueItem.month = 0;
        this.valueItem.day = 0;

        let ddd = { isDate: false, pickerDate: '', date: '', hint: '' };

        if (!date) return ddd;
        if (date.includes('T')) {
          date = date.split('T')[0];
          if (!date) return ddd;
        }
        ddd.date = date;

        let splitString = '/';
        let format = this.dateFormat;

        if (date.includes('-')) {
          splitString = '-';
          format = this.dateFormatPicker;
        }
        let yearIndex = this.getDatePartIndex("YYYY", format, splitString);
        let monthIndex = this.getDatePartIndex("MM", format, splitString);
        let dayIndex = this.getDatePartIndex("DD", format, splitString);

        try {
          let df = date.split(splitString);
          if (df.length != 3) return ddd;

          if (df[yearIndex].length != 4) return ddd;
          if (df[monthIndex] < 1 || df[monthIndex] > 12) return ddd;

          let dd = new Date(df[yearIndex], df[monthIndex] - 1, df[dayIndex], 0, 0, 0, 0);

          if (dd.getDate() != df[dayIndex] || dd.getMonth() != df[monthIndex] - 1 || dd.getFullYear() != df[yearIndex]) return ddd;

          ddd.isDate = true;
          ddd.pickerDate = this.dateFormatPicker.replace("MM", df[monthIndex]).replace("DD", df[dayIndex]).replace("YYYY", df[yearIndex])
          ddd.date = this.dateFormat.replace("MM", df[monthIndex]).replace("DD", df[dayIndex]).replace("YYYY", df[yearIndex])
          ddd.hint = dd.toDateString().split(' ').slice(1).join(' ');

          // Use locale for hint
          let languageId = this.getLocale();
          let locale = languageId === 2 ? 'fr-FR' : 'en-US';
          ddd.hint = dd.toLocaleDateString(locale, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });

          this.valueItem.year = df[yearIndex];
          this.valueItem.month = df[monthIndex];
          this.valueItem.day = df[dayIndex];

          return ddd;
        }
        catch {
          return ddd;
        }
      },

      getLocale(){
        let languageId = 1;
        const sOlsUser = sessionStorage.getItem('olsUser');
        const olsUser = sOlsUser != null ? JSON.parse(sOlsUser) : null;

        if(olsUser){
          if(olsUser.userLocale != null && olsUser.userLocale != '' && olsUser.userLocale === 'fr'){
            languageId = 2
          }
        }

        return languageId;
      }
    }
  }
</script>
